import axios from "axios";
import dayjs from "dayjs";
import { authorizedHeader } from "./authorization";
import {
  fleetsUrl,
  vehicleAlarmCountUrl,
  vehicleAlarmNameUrl,
  vehicleListApiUrl,
} from "components/Common/endpoints";

export const getVehicleList = async () => {
  const response = await axios({
    method: "GET",
    url: vehicleListApiUrl,
    params: {
      vIdType: null,
      pattern: null,
      page: 0,
      size: 1000,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getFleetList = async () => {
  const response = await axios({
    method: "GET",
    url: fleetsUrl,
    params: {},
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getAlarmNameList = async (partType) => {
  const response = await axios({
    method: "GET",
    url: vehicleAlarmNameUrl,
    params: {
      partType: partType,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getAlarmCounts = async (filterDetails, alarmFilterDetails, partType) => {
  const autoRefresh =
    dayjs(filterDetails?.dateRange?.[1]) > dayjs().subtract(1, "hour");
  const response = await axios({
    method: "POST",
    url: vehicleAlarmCountUrl,
    data: {
      partType,
      fleetId: filterDetails.fleet,
      vehicleId: filterDetails.imeiList.filter((item) => item !== "all"),
      alarms: alarmFilterDetails[partType]
        ? [alarmFilterDetails[partType]]
        : [],
      startTime: Math.floor(filterDetails?.dateRange?.[0]),
      endTime: autoRefresh
        ? Math.floor(dayjs())
        : Math.floor(filterDetails?.dateRange?.[1]),
      page: alarmFilterDetails.current - 1,
      size: alarmFilterDetails.pageSize,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};
